function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (config, isTitle, playinline, tiles, videoExtension) {
      pug_mixins["video-stream"] = pug_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
videoUrl = videoUrl ? `${videoUrl}#t=0.01` : '' // this is a hack to show thumbnail in iOS
videoExtension = videoUrl ? videoUrl.split(/[#?]/)[0].split('.').pop().trim() : ''
pug_html = pug_html + "\u003Cvideo" + (pug_attr("class", pug_classes(["video-js",klass], [false,true]), false, true)+pug_attr("playsinline", playsinline, true, true)+pug_attr("controls", controls, true, true)+" preload=\"auto\""+pug_attr("dir", config.direction, true, true)+pug_attr("poster", poster, true, true)) + "\u003E\u003Csource" + (pug_attr("src", videoUrl, true, true)+pug_attr("type", `video/${videoExtension}`, true, true)) + "\u003E\u003C\u002Fvideo\u003E";
};
pug_mixins["image"] = pug_interp = function(imageUrl, klass, alt){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cimg" + (pug_attr("class", pug_classes([klass], [true]), false, true)+pug_attr("src", imageUrl, true, true)+pug_attr("alt", alt, true, true)) + "\u003E";
};
pug_mixins["multi-content"] = pug_interp = function(prop, obj){
var block = (this && this.block), attributes = (this && this.attributes) || {};
obj = obj || locals;
isTitle = prop === "title"
switch (obj[prop + "Type"]){
case "image":
pug_html = pug_html + "\u003Cdiv" + (" class=\"multi-content-wrapper multi-content-wrapper-image block-md block-lt\""+pug_attr("data-content", obj.image, true, true)) + "\u003E\u003Cdiv class=\"block-sm multi-content-media\"\u003E";
pug_mixins["image"](obj[prop], 'multi-content multi-content-image');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
  break;
case "video":
pug_html = pug_html + "\u003Cdiv class=\"multi-content-wrapper multi-content-wrapper-video block-md block-lt\"\u003E\u003Cdiv class=\"block-sm multi-content-media\"\u003E";
pug_mixins["video-stream"](obj[prop], true, true,"multi-content multi-content-video block-dk");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
  break;
case "audio":
pug_html = pug_html + "\u003Cdiv class=\"multi-content-wrapper multi-content-wrapper-audio block-md block-lt\"\u003E\u003Cdiv class=\"block-sm multi-content-media\"\u003E\u003Caudio" + (" class=\"multi-content multi-content-audio block-dk\""+pug_attr("src", obj[prop], true, true)+pug_attr("playsinline", true, true, true)+" preload=\"auto\""+pug_attr("controls", true, true, true)+pug_attr("dir", config.direction, true, true)) + "\u003E\u003C\u002Faudio\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
  break;
case "iframe":
pug_html = pug_html + "\u003Cdiv class=\"multi-content-wrapper multi-content-wrapper-iframe block-md block-lt\"\u003E\u003Cdiv class=\"block-sm multi-content-iframe\"\u003E";
var iframe = obj[prop].match(/<iframe[^<]*<\/iframe>/)
if (iframe) {
pug_html = pug_html + (null == (pug_interp = iframe[0].replace(/ (width|height)=["'\d\w]+/g, "")) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
  break;
default:
if (isTitle) {
pug_html = pug_html + "\u003Ch2 class=\"multi-content multi-content-text text-xxl\" tabindex=\"0\" id=\"title\"\u003E" + (null == (pug_interp = obj[prop]) ? "" : pug_interp) + "\u003C\u002Fh2\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"multi-content multi-content-text\"\u003E" + (null == (pug_interp = obj[prop]) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
  break;
}
};
// iterate tiles
;(function(){
  var $$obj = tiles;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var tile = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["tile",`tile-${(tiles.length / 2)}`], [false,true]), false, true)+pug_attr("data-index", tile.index, true, true)) + "\u003E\u003Cdiv class=\"tile-content\"\u003E\u003Cdiv class=\"btn btn-solid tile-front\"\u003E\u003Cdiv class=\"content text-xl\"\u003E?\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["btn","btn-solid","tile-back",tile.klass], [false,false,false,true]), false, true)) + "\u003E";
pug_mixins["multi-content"]("content", tile);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var tile = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["tile",`tile-${(tiles.length / 2)}`], [false,true]), false, true)+pug_attr("data-index", tile.index, true, true)) + "\u003E\u003Cdiv class=\"tile-content\"\u003E\u003Cdiv class=\"btn btn-solid tile-front\"\u003E\u003Cdiv class=\"content text-xl\"\u003E?\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["btn","btn-solid","tile-back",tile.klass], [false,false,false,true]), false, true)) + "\u003E";
pug_mixins["multi-content"]("content", tile);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

    }.call(this, "config" in locals_for_with ?
        locals_for_with.config :
        typeof config !== 'undefined' ? config : undefined, "isTitle" in locals_for_with ?
        locals_for_with.isTitle :
        typeof isTitle !== 'undefined' ? isTitle : undefined, "playinline" in locals_for_with ?
        locals_for_with.playinline :
        typeof playinline !== 'undefined' ? playinline : undefined, "tiles" in locals_for_with ?
        locals_for_with.tiles :
        typeof tiles !== 'undefined' ? tiles : undefined, "videoExtension" in locals_for_with ?
        locals_for_with.videoExtension :
        typeof videoExtension !== 'undefined' ? videoExtension : undefined));
    ;;return pug_html;};module.exports=template;